// module factories are used so entry inlining is disabled
// startup
// Load entry module and return exports
var __webpack_exports__ = __webpack_require__.O(undefined, [72], () => (__webpack_require__("KIsC")))
__webpack_exports__ = __webpack_require__.O(__webpack_exports__);
